import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Master from 'front/MasterAdmin';
import React from 'react';
import { useSelector } from 'react-redux';
import { hasErrors } from '../../../common/enums';
import { AppProps, parametreSlice } from '../../../common/store/parametreSlice';
import { AppState, appStore } from '../../../common/store/store';
import { apiJson } from '../../api';
import { Loading } from '../Loading';

const DebutTravauxItem = (props: {
    caption: string,
    onUpdate: (newValue: string) => void,
    onDelete: () => void;
}) => {
    const [value, setValue] = React.useState('');
    const [edit, setEdit] = React.useState(false);


    const applyValue = () => {
        setEdit(false);
        props.onUpdate(value);

    };

    React.useEffect(() => {
        setValue(props.caption);
    }, [props.caption]);

    return edit ? <ListItem dense><TextField value={value} onChange={event => setValue(event.target.value)} onBlur={applyValue} /></ListItem> : <ListItem dense
        secondaryAction={<>
            <IconButton onClick={() => setEdit(true)}><Edit /></IconButton>
            <IconButton onClick={props.onDelete}><Delete /></IconButton>
        </>}><ListItemText primary={value} /></ListItem>;
};

export const Parametres = () => {

    const app = useSelector((state: AppState) => state.parametres.app);
    const [loading, setLoading] = React.useState(false);
    const [contactMinRecaptcha, setContactMinRecaptcha] = React.useState('');
    const [uploadMinRecaptcha, setUploadMinRecaptcha] = React.useState('');
    const [choixDebutTravaux, setchoixDebutTravaux] = React.useState<string[]>([]);
    const [newItem, setnewItem] = React.useState('');
    const [err, setErr] = React.useState<ResponseError[] | undefined>();

    const addNewItem = () => {
        setchoixDebutTravaux(p => p.concat([newItem]));
        setnewItem('');
    };

    React.useEffect(() => {
        if (app) {
            setContactMinRecaptcha(app.contactMinRecaptcha + '');
            setUploadMinRecaptcha(app.uploadMinRecaptcha + '');
            setchoixDebutTravaux(app.choixDebutTravaux);
        }
    }, [app]);

    const onSaveClick = async () => {
        setLoading(true);
        try {
            const result = await apiJson('/admin/parametres', 'post', { contactMinRecaptcha, uploadMinRecaptcha, choixDebutTravaux });
            if (hasErrors(result)) {
                setErr(result);
            } else {
                setErr(undefined);
                appStore.dispatch(parametreSlice.actions.updateApp(result as AppProps));
            }
            setLoading(false);
        } catch (err) {
            alert('Un erreur a eu lieu');
            setLoading(false);
        }
    };
    return <Master>
        {loading ? <Loading /> : null}
        <Typography variant='h1'>Paramètres de l'application</Typography>
        <Stack spacing={3} sx={{ m: 2 }}>
            <TextField
                value={contactMinRecaptcha}
                label='Score minimum pour interagir avec le formulaire de contact (entrer 0 et 1)'
                onChange={event => {
                    setContactMinRecaptcha(event.target.value);
                }}
                type='number'
                error={!!err?.find(p => p.param == 'contactMinRecaptcha')}
                helperText={err?.find(p => p.param == 'contactMinRecaptcha')?.msg}
            />
            <TextField
                value={uploadMinRecaptcha}
                label='Score minimum pour téléverser des fichiers (entrer 0 et 1)'
                onChange={event => {
                    setUploadMinRecaptcha(event.target.value);
                }}
                type='number'
                error={!!err?.find(p => p.param == 'uploadMinRecaptcha')}
                helperText={err?.find(p => p.param == 'uploadMinRecaptcha')?.msg}
            />
            <Typography variant='h3'>Choix de début des travaux</Typography>
            {choixDebutTravaux.map((p, index) => <DebutTravauxItem caption={p} onUpdate={(newValue) => {
                setchoixDebutTravaux(choixDebutTravaux.map((q, i) => {
                    return i === index ? newValue : q;
                }));
            }} onDelete={() => {
                let yo = [...choixDebutTravaux];
                yo.splice(index, 1);
                setchoixDebutTravaux(yo);
            }} />)}
            <ListItem dense><TextField placeholder="Ajouter un choix" value={newItem} onChange={event => setnewItem(event.target.value)} onBlur={addNewItem} /></ListItem>
        </Stack>
        <Button variant='contained' onClick={onSaveClick}>Sauvegarder</Button>
    </Master>;
};
